import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    set(_, action) {
      return action.payload;
    },
    update(state, action) {
      return { ...state, ...action.payload };
    },
    request() { /* do nothing */ },
    requestDay() { /* do nothing */ },
    success() { /* do nothing */ },
    failure() { /* do nothing */ },
  },
});

export const history = historySlice.actions;
export default historySlice.reducer;
